// for Normal video
// let playVideo = document.querySelector('video.player');
// if(playVideo) {
//   $('.video-wrapper .play-icon').on('click touchstart', function() {
//       console.log('Play icon clicked');
//       let wrapper = $(this).closest('.video-wrapper');
//       let video = wrapper.find('.player').get(0);
  
//       setTimeout(function() {
//           video.muted = true; // Mute the video
//           video.loop = true; // Loop the video
//           video.play(); // Play the video
  
//           // Hide the play icon and overlay
//           wrapper.find('.play-icon').hide();
//           wrapper.find('.image-over-layer').hide();
//       }, 500);
//   });
// }
// // Youtube video
// let playiframe = document.querySelector('iframe#player');
//   if (playiframe) {
//    document.addEventListener('DOMContentLoaded', function() {
//       document.querySelector('.video-wrapper .play-icon').addEventListener('click', function() {
//           let iframe = document.getElementById('player');
//           let iframeSrc = iframe.getAttribute('src');
  
//           if (iframeSrc.includes('?')) {
//               iframe.setAttribute('src', iframeSrc + '&autoplay=1&loop=1&autopause=0&muted=1');
//           } else {
//               iframe.setAttribute('src', iframeSrc + '?autoplay=1&loop=1&autopause=0&muted=1');
//           }
  
//           this.style.display = 'none';
//           document.querySelector('.video-wrapper .image-over-layer').style.display = 'none';
//       });
//   });
// }

/* ===========================================================================
   Video loading strategy — runtime, because the markup is not always ours
   ---------------------------------------------------------------------------
   The <video> elements on the Rolex COLLECTION pages are not authored in the
   theme at all: collection.rolex-custom-collection.liquid prints a collection
   metafield as raw HTML, and the merchant's blob contains
   `<video controls class="player" loop>` with no preload, no poster and — the
   part that actually broke mobile — no playsinline. Liquid cannot reach those
   attributes, so they are normalised here instead, which also covers the
   template-authored ones.

   Measured before this pass on /collections/rolex-datejust at 390x844:
   two videos, 1.65MB and 4.69MB, both preload=metadata, buffering 0.4s/0.5s
   for ~44KB total. So this is NOT the page-weight problem (third-party apps
   are: 169 requests / 2.62MB). It is the PLAYABILITY problem, and preload
   "none" simply makes the byte cost exactly zero until someone taps.
   =========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.video-wrapper video').forEach(function (v) {
    if (v.dataset.loadStrategy) return;
    v.dataset.loadStrategy = 'tap';

    /* Nothing downloads at page open. These are all click-to-play (they carry
       `controls` and sit under a poster overlay); none is an ambient/autoplay
       background video, so there is no IntersectionObserver preload to do —
       the facade IS the lazy trigger. */
    try { v.preload = 'none'; v.setAttribute('preload', 'none'); } catch (e) {}

    /* iOS will not play an inline <video> without this. The metafield markup
       has no way to carry it. */
    try {
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
    } catch (e) {}

    /* ---- Source upgrade: raw original -> Shopify's H.264 transcode --------
       The collection metafields link the ORIGINAL upload:
         https://cdn.shopify.com/videos/c/o/v/<hash>.mp4
       Measured: despite the .mp4 extension and a `Content-Type: video/mp4`
       header, those bytes are WebM — magic 1a45dfa3, DocType "webm", VP9 video
       + Vorbis audio, muxed by Lavf60.3.100. Desktop Chrome decodes VP9 happily,
       which is exactly why this only ever failed on the phone.

       Shopify has already transcoded these to H.264/AAC; the ladder is at
         https://cdn.shopify.com/videos/c/vp/<hash>/<hash>.m3u8
       (1080p/720p/480p, CODECS="avc1.*,mp4a.40.2", CORS `*`). The hash is the
       only variable, so the URL is derivable from what is already on the page —
       no numeric rendition id to look up.

       Only browsers with native HLS (Safari/iOS) are switched. Everything else
       already decodes the VP9 original fine, and the H.264 renditions are
       actually LARGER (5.70MB vs 4.69MB at 720p), so there is nothing to gain
       by moving Chrome onto them.

       src is assigned directly rather than appending a <source>: dynamically
       added <source> children are not re-evaluated, so they would be ignored
       until an explicit load() — which the tap handler now performs anyway. */
    try {
      var raw = (v.currentSrc || v.getAttribute('src') ||
                 (v.querySelector('source') && v.querySelector('source').getAttribute('src')) || '');
      var m = raw.match(/cdn\.shopify\.com\/videos\/c\/o\/v\/([0-9a-f]{32})\.(?:mp4|mov|webm|m4v)/i);
      /* Discriminator is VP9-WebM capability, NOT canPlayType('...mpegurl').
         Chrome answers "maybe" to the HLS type despite having no native HLS
         player (measured in headless Chrome), so keying on that wrongly moved
         Chrome — which plays the VP9 original perfectly — onto a stream it
         cannot demux. Asking whether the device can decode the file we actually
         have is the honest test:
           Chrome / Android : vp9 "probably" -> keep the original, nothing changes
           iOS Safari       : vp9 ""         -> cannot decode it, switch to HLS  */
      var canVp9    = !!(v.canPlayType && v.canPlayType('video/webm; codecs="vp9"'));
      var nativeHls = !!(v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl'));
      v.dataset.srcDecision = !m ? 'not-a-shopify-original'
        : canVp9  ? 'kept-original (device decodes VP9)'
        : nativeHls ? 'upgraded-to-hls (device cannot decode VP9)'
        : 'kept-original (no VP9 and no native HLS — nothing better to offer)';
      if (m && !canVp9 && nativeHls) {
        var hls = 'https://cdn.shopify.com/videos/c/vp/' + m[1] + '/' + m[1] + '.m3u8';
        v.dataset.srcOriginal = raw;
        v.removeAttribute('src');
        v.src = hls;
        v.dataset.srcUpgraded = hls;
      }
    } catch (e) { v.dataset.srcDecision = 'error: ' + e.message; }

    /* If the source turns out to be undecodable on this device, keep the poster
       and the play button rather than leaving a dead black frame. */
    v.addEventListener('error', function () {
      /* If the upgraded stream fails (no transcode for this asset, network,
         whatever), fall back to the original once rather than dead-ending. */
      if (v.dataset.srcUpgraded && v.dataset.srcOriginal && !v.dataset.srcReverted) {
        v.dataset.srcReverted = '1';
        v.dataset.srcDecision = 'reverted-to-original (HLS errored)';
        v.src = v.dataset.srcOriginal;
        try { v.load(); } catch (e) {}
        return;
      }
      var wrap = v.closest && v.closest('.video-wrapper');
      if (!wrap) return;
      var ov = wrap.querySelector('.image-over-layer');
      var btn = wrap.querySelector('.play-button, .play-icon');
      if (ov) ov.style.display = '';
      if (btn) btn.style.display = '';
      console.warn('[video-overlay] media error code',
        v.error && v.error.code, '— source not decodable on this device:', v.currentSrc);
    });

    /* With preload="none" the element paints nothing until it loads, so give it
       the overlay artwork as a poster — same image the facade already shows, so
       it costs no extra request. */
    if (!v.getAttribute('poster')) {
      var wrap = v.closest && v.closest('.video-wrapper');
      var img = wrap && wrap.querySelector('.image-over-layer img');
      var src = img && (img.currentSrc || img.getAttribute('src'));
      if (src) v.setAttribute('poster', src);
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.video-wrapper .play-button, .video-wrapper .play-icon').forEach(function (btn) {
    /* Some sections ship their own handler for the same button (e.g.
       rolex-new-watches-detail, which drives a YouTube IFrame API player). They
       mark the button with data-video-bound; without this guard BOTH handlers
       run on one tap and play() is called two or three times. Measured on a
       real tap before this guard: 3 play() calls for a single press. */
    if (btn.dataset.videoBound) {
      /* Someone else (a section-level script) claimed this button first. */
      btn.dataset.videoOwner = btn.dataset.videoOwner || 'other-script (section-level)';
      return;
    }
    btn.dataset.videoBound = '1';
    btn.dataset.videoOwner = 'rolex-custom.js';

    btn.addEventListener('click', function () {
      var wrapper = this.closest('.video-wrapper');
      var video   = wrapper.querySelector('video.player');
      var ytId    = wrapper.getAttribute('data-youtube-id');
      var ytSlot  = wrapper.querySelector('.youtube-embed-slot');

      if (ytId && ytSlot) {
        // ---- YouTube video ----
        if (!ytSlot.querySelector('iframe')) {
          var iframe = document.createElement('iframe');
          iframe.className = 'player youtube-player';
          iframe.src = 'https://www.youtube.com/embed/' + ytId
                     + '?autoplay=1&mute=1&loop=1&playlist=' + ytId
                     + '&controls=1&rel=0&modestbranding=1&playsinline=1';
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
          iframe.setAttribute('allowfullscreen', '');
          ytSlot.appendChild(iframe);
        }
      } else if (video) {
        // ---- Uploaded video (Shopify-hosted or direct MP4) ----
        /* playsInline is the fix for mobile. Without it iOS will not play an
           inline <video> at all — it routes playback to the fullscreen player,
           and that transition is refused unless a gesture is still live. The
           markup carries the `playsinline` attribute; this sets the matching
           property too, because some engines only honour the property when
           play() is invoked programmatically.

           Muting is NOT forced any more. This play() runs synchronously inside
           the tap, and a gesture permits audio — forcing mute made an
           uploaded video behave differently from the YouTube branch beside it
           for no policy reason. loop stays. */
        video.playsInline = true;
        video.loop = true;
        /* preload="none" means no data is buffered yet; kick the fetch off in
           the same tick as the tap so the gesture still covers the play(). */
        if (video.readyState === 0) { try { video.load(); } catch (e) {} }

        var played = video.play();
        if (played && played.catch) {
          played.catch(function (err) {
            /* Name the policy instead of leaving a black rectangle, and put the
               facade back so the user has something to tap again. */
            console.warn('[video-overlay] play() rejected:', err && err.name, err && err.message);
            var ov = wrapper.querySelector('.image-over-layer');
            if (ov) ov.style.display = '';
            btn.style.display = '';
          });
        }
      }

      var overlay = wrapper.querySelector('.image-over-layer');
      if (overlay) overlay.style.display = 'none';
      this.style.display = 'none';
    });
  });
});

if (document.body.classList.contains('product-custom-rolex')) {
  document.querySelectorAll('.model-info_spec_heading').forEach(function(element) {
      const addClassHeading = element.textContent.toLowerCase().replace(/\s+/g, '');
      element.classList.add(addClassHeading);
  });
}


// article page published-date shifting
const publishDate = document.querySelector('#publish-date');
if (publishDate) {
  let shiftedPublishedDate = publishDate.cloneNode(true);
  let targetElement = publishDate.parentElement.nextElementSibling.nextElementSibling.querySelector('.content-section')
  if(targetElement){
    targetElement.appendChild(shiftedPublishedDate);
  }
  publishDate.style.display = "none";
}



// rolex-custom-nav Start
document.querySelectorAll('.rolexNav-toggle').forEach(function(item) {
    item.addEventListener('click', function(e) {
        const target = '.' + e.currentTarget.getAttribute('data-target');
        if (e.currentTarget.classList.contains('is-open')) {
            e.currentTarget.classList.remove('is-open');
            document.querySelector(target).classList.remove('is-open');
        } else {
            document.querySelector(target).classList.add('is-open');
            e.currentTarget.classList.add('is-open');
        }
    });
});

if (document.querySelectorAll('a.rolex-upArrow').length > 0) {
    document.querySelectorAll('a.rolex-upArrow').forEach(function(item) {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            const target = e.currentTarget.getAttribute('href');
            const offsetTop = document.querySelector(target).offsetTop;
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        });
    });
}
// rolex-custom-nav End


// rolex custom carousel Start
if (document.querySelector('#explorecarousel-slider')) {
if (document.querySelectorAll('#explorecarousel-slider .exploreCarousel-item-custom').length > 4) {
    var flkty = new Flickity('#explorecarousel-slider .exploreCarousel-list', {
        cellAlign: 'left',
        contain: true,
        wrapAround: false,
        lazyLoad: 2,
        prevNextButtons: true,
        pageDots: true,
        groupCells: true,
        autoPlay: false, 
        dragThreshold: 10,
        selectedAttraction: 0.2, 
        friction: 0.8, 
        slidesToShow: 2, 
        slidesToScroll: 2, 
       responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ]
    });
}
}
// custom carousel End


// Banner slider
if (document.querySelector('#banner-slider')) {
    if (document.querySelectorAll('#banner-slider .exploreCarousel-item-banner').length > 1) {
        var flkty = new Flickity('#banner-slider .exploreCarousel-list', {
            cellAlign: 'left',
            contain: true,
             wrapAround: false,
            lazyLoad: 2,
            prevNextButtons: true,
            pageDots: true,
            groupCells: true,
            autoPlay: false, 
            dragThreshold: 10,
            selectedAttraction: 0.2, 
            friction: 0.8, 
            slidesToShow: 1, 
            slidesToScroll: 1, 
        });
    }
}


// rolex custom collection carousel Start
if (document.querySelector('#collections-slider')) {
if (document.querySelectorAll('#collections-slider .exploreCarousel-item-collection-carousel').length > 4) {
    var flkty = new Flickity('#collections-slider .exploreCarousel-list', {
        cellAlign: 'left',
        contain: true,
         wrapAround: false,
        lazyLoad: 2,
        prevNextButtons: true,
        pageDots: true,
        groupCells: true,
        autoPlay: false, 
        dragThreshold: 10,
        selectedAttraction: 0.2, 
        friction: 0.8, 
        slidesToShow: 2, 
        slidesToScroll: 2, 
       responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ]
    });
}
}
// custom carousel End

// rolex custom carousel Start
if (document.querySelector('#new-watches-carousel')) {
if (document.querySelectorAll('#new-watches-carousel .exploreCarousel-item-new-watches').length > 4) {
    var flkty = new Flickity('#new-watches-carousel .exploreCarousel-list', {
        cellAlign: 'left',
        contain: true,
         wrapAround: false,
        lazyLoad: 2,
        prevNextButtons: true,
        pageDots: true,
        groupCells: true,
        autoPlay: false, 
        dragThreshold: 10,
        selectedAttraction: 0.2, 
        friction: 0.8, 
        slidesToShow: 2, 
        slidesToScroll: 2, 
       responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ]
    });
}
}
// custom carousel End


/* Products Load More button */

$(document).ready(function() {
  
  var numberOfProductsToShow = 6;
  if (window.location.pathname.includes("/collections/rolex-accessories")) {
        numberOfProductsToShow = 10;
    }

    if (window.location.pathname.includes("/collections/festive-selection")) {
        numberOfProductsToShow = 15;
    }

  function showProducts(startIndex, endIndex) {
    $('.custom-collection-list .product').each(function(index, product) {
      if (index >= startIndex && index < endIndex) {
        $(product).css('display', 'block');
      } else {
        $(product).css('display', 'none');
      }
    });

    var loadMore = $('.product-load-more-btn');
    if (endIndex >= $('.custom-collection-list .product').length) {
      loadMore.hide();
    } else {
      loadMore.show();
    }
  }

  showProducts(0, numberOfProductsToShow);

  $('.product-load-more-btn').on('click', function() {
    var loadMore = $(this);
    loadMore.html("Loading...");
    setTimeout(function() {
      numberOfProductsToShow += 6;
      showProducts(0, numberOfProductsToShow);
      loadMore.html("Load more");
    }, 1000);
  });
});


// Store Opening time

 // The day of the week (0 to 6). Sunday = 0 etc.
const date = new Date();
const today = date.getDay().toString();
const daysList = $('div.hoursItem');
// updates the current hours of the store on the dropdown of the individual contact pages
for (let index = 0; index < daysList.length; index++) {
    const day = daysList[index];
    if (today === $(day).attr('data-day').toString()) {
        if ($(day).find('strong span.hours').text().toLowerCase() === 'closed') {
            $('label.currentHours').addClass('closed');
        }
        const data = $(day).find('.hours').text();
        $('label.currentHours strong .hours').text(data);
    }
}
// dropdown toggle
$('button.hoursList-toggle').on('click', (e) => {
    if ($('div.hoursList').hasClass('is-active')) {
        $('div.hoursList').removeClass('is-active');
        $(e.currentTarget).removeClass('is-active');
    } else {
        $(e.currentTarget).addClass('is-active');
        $('div.hoursList').addClass('is-active');
    }
});




/* ===============================================
  #Lazyframe
================================================== */
/* Lazyframe */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):e.lazyframe=t()}(this,function(){"use strict";var e=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(e[i]=n[i])}return e};return function(){function t(t){if(d=e({},m,arguments.length<=1?void 0:arguments[1]),"string"==typeof t)for(var i=document.querySelectorAll(t),o=0;o<i.length;o++)n(i[o]);else if(void 0===t.length)n(t);else if(t.length>1)for(var r=0;r<t.length;r++)n(t[r]);else n(t[0]);d.lazyload&&a()}function n(e){var t=this;if(e instanceof HTMLElement!=!1&&!e.classList.contains("lazyframe--loaded")){var n={el:e,settings:i(e)};n.el.addEventListener("click",function(){n.el.appendChild(n.iframe);var i=e.querySelectorAll("iframe");n.settings.onAppend.call(t,i[0])}),d.lazyload?l(n):u(n,!!n.settings.thumbnail)}}function i(t){var n=Array.prototype.slice.apply(t.attributes).filter(function(e){return""!==e.value}).reduce(function(e,t){return e[0===t.name.indexOf("data-")?t.name.split("data-")[1]:t.name]=t.value,e},{}),i=e({},d,n,{y:t.offsetTop,parameters:o(n.src)});if(i.vendor){var r=i.src.match(p.regex[i.vendor]);i.id=p.condition[i.vendor](r)}return i}function o(e){var t=e.split("?");if(t[1]){t=t[1];return-1!==t.indexOf("autoplay")?t:t+"&autoplay=1"}return"autoplay=1"}function r(e){return!!e.vendor&&((!e.title||!e.thumbnail)&&("youtube"!==e.vendor&&"youtube_nocookie"!==e.vendor||!!e.apikey))}function u(e){var t=this;r(e.settings)?s(e,function(n,i){if(!n){var o=i[0],r=i[1];if(r.settings.title||(r.settings.title=p.response[r.settings.vendor].title(o)),!r.settings.thumbnail){var u=p.response[r.settings.vendor].thumbnail(o);r.settings.thumbnail=u,e.settings.onThumbnailLoad.call(t,u)}l(r,!0)}}):l(e,!0)}function s(e,t){var n=p.endpoints[e.settings.vendor](e.settings),i=new XMLHttpRequest;i.open("GET",n,!0),i.onload=function(){if(i.status>=200&&i.status<400){var n=JSON.parse(i.responseText);t(null,[n,e])}else t(!0)},i.onerror=function(){t(!0)},i.send()}function a(){var e=this,t=window.innerHeight,n=f.length,i=function(t,i){t.settings.initialized=!0,t.el.classList.add("lazyframe--loaded"),n--,u(t),t.settings.initinview&&t.el.click(),t.settings.onLoad.call(e,t)};f.filter(function(e){return e.settings.y<t}).forEach(i);var o=function(e,t,n){var i=void 0;return function(){var o=this,r=arguments,u=function(){i=null,n||e.apply(o,r)},s=n&&!i;clearTimeout(i),i=setTimeout(u,t),s&&e.apply(o,r)}}(function(){s=r<window.pageYOffset,r=window.pageYOffset,s&&f.filter(function(e){return e.settings.y<t+r&&!1===e.settings.initialized}).forEach(i),0===n&&window.removeEventListener("scroll",o,!1)},d.debounce),r=0,s=!1;window.addEventListener("scroll",o,!1)}function l(e,t){if(e.iframe=c(e.settings),e.settings.thumbnail&&t&&(e.el.style.backgroundImage="url("+e.settings.thumbnail+")"),e.settings.title&&0===e.el.children.length){var n=document.createDocumentFragment(),i=document.createElement("span");i.className="lazyframe__title",i.innerHTML=e.settings.title,n.appendChild(i),e.el.appendChild(n)}d.lazyload||(e.el.classList.add("lazyframe--loaded"),e.settings.onLoad.call(this,e),f.push(e)),e.settings.initialized||f.push(e)}function c(e){var t=document.createDocumentFragment(),n=document.createElement("iframe");if(e.vendor&&(e.src=p.src[e.vendor](e)),n.setAttribute("id","lazyframe-"+e.id),n.setAttribute("src",e.src),n.setAttribute("frameborder",0),n.setAttribute("allowfullscreen",""),"vine"===e.vendor){var i=document.createElement("script");i.setAttribute("src","https://platform.vine.co/static/scripts/embed.js"),t.appendChild(i)}return t.appendChild(n),t}var d=void 0,f=[],m={vendor:void 0,id:void 0,src:void 0,thumbnail:void 0,title:void 0,apikey:void 0,initialized:!1,parameters:void 0,y:void 0,debounce:250,lazyload:!0,initinview:!1,onLoad:function(e){},onAppend:function(e){},onThumbnailLoad:function(e){}},p={regex:{youtube_nocookie:/(?:youtube-nocookie\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v\=)))([a-zA-Z0-9_-]{6,11})/,youtube:/(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v\=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/,vimeo:/vimeo\.com\/(?:video\/)?([0-9]*)(?:\?|)/,vine:/vine.co\/v\/(.*)/},condition:{youtube:function(e){return!(!e||11!=e[1].length)&&e[1]},youtube_nocookie:function(e){return!(!e||11!=e[1].length)&&e[1]},vimeo:function(e){return!!(e&&9===e[1].length||8===e[1].length)&&e[1]},vine:function(e){return!(!e||11!==e[1].length)&&e[1]}},src:{youtube:function(e){return"https://www.youtube.com/embed/"+e.id+"/?"+e.parameters},youtube_nocookie:function(e){return"https://www.youtube-nocookie.com/embed/"+e.id+"/?"+e.parameters},vimeo:function(e){return"https://player.vimeo.com/video/"+e.id+"/?"+e.parameters},vine:function(e){return"https://vine.co/v/"+e.id+"/embed/simple"}},endpoints:{youtube:function(e){return"https://www.googleapis.com/youtube/v3/videos?id="+e.id+"&key="+e.apikey+"&fields=items(snippet(title,thumbnails))&part=snippet"},youtube_nocookie:function(e){return"https://www.googleapis.com/youtube/v3/videos?id="+e.id+"&key="+e.apikey+"&fields=items(snippet(title,thumbnails))&part=snippet"},vimeo:function(e){return"https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/"+e.id},vine:function(e){return"https://vine.co/oembed.json?url=https%3A%2F%2Fvine.co%2Fv%2F"+e.id}},response:{youtube:{title:function(e){return e.items[0].snippet.title},thumbnail:function(e){var t=e.items[0].snippet.thumbnails;return(t.maxres||t.standard||t.high||t.medium||t.default).url}},youtube_nocookie:{title:function(e){return e.items[0].snippet.title},thumbnail:function(e){var t=e.items[0].snippet.thumbnails;return(t.maxres||t.standard||t.high||t.medium||t.default).url}},vimeo:{title:function(e){return e.title},thumbnail:function(e){return e.thumbnail_url}},vine:{title:function(e){return e.title},thumbnail:function(e){return e.thumbnail_url}}}};return t}()});




/* Contact page MAP and List tab code */

  document.addEventListener("DOMContentLoaded", function() {
    var storesListLink = document.getElementById('stores_list_link');
    var storesMapLink = document.getElementById('stores_map_link');
    var mapView = document.getElementById('map_view');
    var listView = document.getElementById('list_view');
    var mapCanvas = document.getElementById('map_canvas');

    storesListLink.addEventListener("click", function(e) {
      e.preventDefault();
      mapView.style.display = 'none';
      listView.style.display = 'flex';
      storesListLink.classList.add('active');
      storesMapLink.classList.remove('active');
    });

    storesMapLink.addEventListener("click", function(e) {
      e.preventDefault();
      mapView.style.display = 'block';
      listView.style.display = 'none';
      storesListLink.classList.remove('active');
      storesMapLink.classList.add('active');
    });

    zipcode = 89109;
    var t = window.outerWidth
  });


// Contact us and Store pages MAP Code

    function goToByScroll(id) {
        $('html,body').animate({
            scrollTop: $("#" + id).offset().top
        }, 'slow');
    }
                
    $(document).ready(function() {
        // zipcode = 89109;
        var t = $(window).outerWidth();

        $('#map_canvas').css('height', '550px');

        initialize_map();

    });
                
   function initialize_map() {

        var locations = [['Manfredi Jewels', '41.0290067', '-73.7084403', '0', 'Manfredi Jewels, 121 Greenwich Ave, Greenwich, CT 06830, United States', '203-625-1543', 'monostore?store_id=8', 'https://g.co/kgs/k4zo7c8', '/public/AMPFUSION/brands/skeleton/images/stock2_300x220.jpg']];
        var map = new google.maps.Map(document.getElementById('map_canvas'),{
            zoom: 13,
            center: new google.maps.LatLng(41.0290067,-73.7084403),
            mapTypeControlOptions: {
                mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'tehgrayz']
            }
        });
       var stylez = [{
                "featureType": "administrative",
                "elementType": "all",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "administrative",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#6e6c6c"
                }]
            }, {
                "featureType": "administrative.country",
                "elementType": "geometry",
                "stylers": [{
                    "weight": "0.85"
                }, {
                    "lightness": "45"
                }, {
                    "visibility": "on"
                }]
            }, {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [{
                    "color": "#f2f2f2"
                }]
            }, {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [{
                    "gamma": "1.09"
                }, {
                    "lightness": "19"
                }]
            }, {
                "featureType": "landscape",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "on"
                }, {
                    "lightness": "-21"
                }, {
                    "weight": "0.01"
                }]
            }, {
                "featureType": "landscape.natural.landcover",
                "elementType": "geometry",
                "stylers": [{
                    "saturation": "8"
                }, {
                    "lightness": "8"
                }]
            }, {
                "featureType": "landscape.natural.landcover",
                "elementType": "geometry.fill",
                "stylers": [{
                    "lightness": "6"
                }]
            }, {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [{
                    "visibility": "off"
                }, {
                    "saturation": "1"
                }, {
                    "color": "#cfe1d3"
                }]
            }, {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "poi.attraction",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "poi.medical",
                "elementType": "geometry.fill",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "poi.medical",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "on"
                }, {
                    "color": "#cfe1d3"
                }]
            }, {
                "featureType": "road",
                "elementType": "all",
                "stylers": [{
                    "saturation": -100
                }, {
                    "lightness": 45
                }]
            }, {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "on"
                }, {
                    "color": "#dcdfe2"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "road.highway.controlled_access",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "road.highway.controlled_access",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.highway.controlled_access",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.local",
                "elementType": "geometry.fill",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.local",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "transit",
                "elementType": "geometry.fill",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "transit.station",
                "elementType": "all",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [{
                    "gamma": "1.57"
                }, {
                    "lightness": "-10"
                }]
            }, {
                "featureType": "transit.station",
                "elementType": "labels",
                "stylers": [{
                    "weight": "0.01"
                }, {
                    "visibility": "on"
                }, {
                    "saturation": "-100"
                }, {
                    "lightness": "-3"
                }]
            }, {
                "featureType": "transit.station",
                "elementType": "labels.icon",
                "stylers": [{
                    "weight": "0.01"
                }]
            }, {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#c2d8e1"
                }]
            }, {
                "featureType": "water",
                "elementType": "labels.text",
                "stylers": [{
                    "visibility": "on"
                }, {
                    "color": "#b0bdc7"
                }]
            }];
					
        var mapType = new google.maps.StyledMapType(stylez,{
            name: "Locations"
        });
        map.mapTypes.set('tehgrayz', mapType);
        map.setMapTypeId('tehgrayz');

        var marker, i;

        for (i = 0; i < locations.length; i++) {
            marker = new google.maps.Marker({
                position: new google.maps.LatLng(locations[i][1],locations[i][2]),
                map: map,
                icon: 'https://s3.amazonaws.com/ISHOWIMAGES/Rolex/Rolex+Module/Contact+Us+Pages/retailer.png'
            });

            google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {

                    marker.setIcon('https://s3.amazonaws.com/ISHOWIMAGES/Rolex/Rolex+Module/Contact+Us+Pages/retailer_selected.png');

                    $('#selected_store_details').css('visibility', 'visible');
                    $('#selected_store_details').css('opacity', 1);
                    map.setZoom(18);
                    map.panTo(this.getPosition());

                    $('#rolex_store_name').html(locations[i][0]);
                    $('#rolex_store_address').html(locations[i][4]);
                    $('#rolex_store_phone').html(locations[i][5]);
                    $("#rlxContactCall").attr("href", "tel:" + locations[i][5]);
                    $("#rolex_store_link").attr("href", locations[i][6]);
                    $("#rolex_store_directions").attr("href", locations[i][7]);
                    $("#store_image").css("background-image", "url(" + locations[i][8] + ")");

                    $('#store_close_button').on('click', (function(e) {
                        e.preventDefault();
                        map.setZoom(13);
                        map.setCenter(new google.maps.LatLng(41.0290067,-73.7084403));
                        $('#selected_store_details').css('visibility', 'hidden');
                        $('#selected_store_details').css('opacity', 0);

                        marker.setIcon('https://s3.amazonaws.com/ISHOWIMAGES/Rolex/Rolex+Module/Contact+Us+Pages/retailer.png');

                    }
                    ));
                }
            }
            )(marker, i));

        }
    }


           

/* ===========================================================================
   TEMPORARY DEBUG INSTRUMENTATION — REMOVE AFTER DIAGNOSIS
   ---------------------------------------------------------------------------
   Renders a live readout of the Shopify-hosted <video> state, and ONLY when the
   URL carries ?videodebug=1. Without that flag not a single statement below
   runs past the first `if`, so the production path is untouched.

   It lives in this shared asset (loaded globally from layout/theme.liquid)
   rather than in one template, so it reports on whichever page carries a
   .video-wrapper — showroom, the Rolex collection templates, or the
   rolex-new-watches-detail section.

   Everything is wrapped in try/catch: a debug panel must never be able to break
   the page it is diagnosing.
   =========================================================================== */
(function () {
  'use strict';

  var FLAG = /(?:^|[?&])videodebug=1(?:&|$)/.test(window.location.search);
  if (!FLAG) return;

  var state = [];          // per-wrapper records
  var playLog = [];        // global play() promise outcomes
  var tapLog = [];         // real event path for taps inside a .video-wrapper
  var T0 = performance.now();
  var ms = function () { return (performance.now() - T0).toFixed(0) + 'ms'; };

  /* ---- Capture every play() call and its promise outcome, whoever calls it -- */
  try {
    var origPlay = HTMLMediaElement.prototype.play;
    HTMLMediaElement.prototype.play = function () {
      var el = this;
      var line = '[' + ms() + '] play() called  muted=' + el.muted
        + ' playsInline=' + el.playsInline
        + ' readyState=' + el.readyState
        + ' gesture=' + (navigator.userActivation ? navigator.userActivation.isActive : 'n/a');
      playLog.push(line);
      var r;
      try { r = origPlay.apply(this, arguments); } catch (e) {
        playLog.push('[' + ms() + '] play() THREW SYNCHRONOUSLY: ' + e.name + ' — ' + e.message);
        render();
        throw e;
      }
      if (r && r.then) {
        r.then(function () { playLog.push('[' + ms() + '] play() RESOLVED (playback started)'); render(); },
               function (e) { playLog.push('[' + ms() + '] play() REJECTED: ' + e.name + ' — ' + e.message); render(); });
      } else {
        playLog.push('[' + ms() + '] play() returned no promise (legacy)');
      }
      render();
      return r;
    };
  } catch (e) { playLog.push('could not hook play(): ' + e.message); }

  /* Handlers for this component are bound in several places and to several
     targets: assets/rolex-custom.js binds `.play-button`, some templates bind
     `.play-button` inline, and collection.rolex-custom-collection.liquid binds
     the WRAPPER itself. A button-level ownership tag cannot see the last one,
     so log the real event path in the capture phase instead — this reports what
     the device actually did, whoever is listening. */
  try {
    ['touchstart', 'click'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        var w = e.target && e.target.closest && e.target.closest('.video-wrapper');
        if (!w) return;
        var t = e.target;
        tapLog.push('[' + ms() + '] ' + evt + ' target=<' + t.tagName.toLowerCase()
          + (t.className ? ' class="' + String(t.className).slice(0, 40) + '"' : '') + '>');
        render();
      }, true);
    });
  } catch (e) { tapLog.push('could not hook tap logging: ' + e.message); }

  var MEDIA_EVENTS = ['loadstart','loadedmetadata','loadeddata','canplay','canplaythrough',
                      'play','playing','pause','waiting','stalled','suspend','abort','emptied','error'];
  var READY = ['0 HAVE_NOTHING','1 HAVE_METADATA','2 HAVE_CURRENT_DATA','3 HAVE_FUTURE_DATA','4 HAVE_ENOUGH_DATA'];
  var NET   = ['0 NETWORK_EMPTY','1 NETWORK_IDLE','2 NETWORK_LOADING','3 NETWORK_NO_SOURCE'];
  var ERRC  = {1:'1 MEDIA_ERR_ABORTED',2:'2 MEDIA_ERR_NETWORK',3:'3 MEDIA_ERR_DECODE',4:'4 MEDIA_ERR_SRC_NOT_SUPPORTED'};

  var panel, pre;
  function buildPanel() {
    panel = document.createElement('div');
    panel.setAttribute('data-videodebug', '');
    panel.style.cssText = [
      'position:fixed','left:0','right:0','bottom:0','z-index:2147483647',
      'max-height:40vh','overflow:auto','-webkit-overflow-scrolling:touch',
      'background:#fff','color:#000','border-top:2px solid #000',
      'box-shadow:0 -4px 12px rgba(0,0,0,.35)'
    ].join(';');
    pre = document.createElement('pre');
    pre.style.cssText = [
      'margin:0','padding:8px 10px',
      'font:12px/1.35 ui-monospace,SFMono-Regular,Menlo,Consolas,monospace',
      'white-space:pre-wrap','word-break:break-all','color:#000','background:#fff'
    ].join(';');
    var close = document.createElement('button');
    close.textContent = 'hide';
    close.style.cssText = 'position:sticky;top:0;float:right;margin:4px;font:12px monospace;padding:4px 8px;';
    close.addEventListener('click', function () { panel.style.display = 'none'; });
    panel.appendChild(close);
    panel.appendChild(pre);
    (document.body || document.documentElement).appendChild(panel);
  }

  function describeEl(el) {
    if (!el) return '(none)';
    var cs = getComputedStyle(el);
    var r = el.getBoundingClientRect();
    return 'display=' + cs.display + ' visibility=' + cs.visibility + ' opacity=' + cs.opacity
         + ' box=' + Math.round(r.width) + 'x' + Math.round(r.height)
         + ' position=' + cs.position;
  }

  function resourceEntry(url) {
    if (!url) return '(no currentSrc)';
    try {
      var hits = performance.getEntriesByType('resource').filter(function (e) { return e.name === url; });
      if (!hits.length) return 'NO network request recorded for this URL';
      var h = hits[hits.length - 1];
      return 'request made: duration=' + h.duration.toFixed(0) + 'ms transferSize=' + (h.transferSize || 0)
           + ' encodedBodySize=' + (h.encodedBodySize || 0);
    } catch (e) { return 'resource-timing unavailable: ' + e.message; }
  }

  function init() {
    try {
      buildPanel();
      var wrappers = Array.prototype.slice.call(document.querySelectorAll('.video-wrapper'));
      wrappers.forEach(function (w, i) {
        var video = w.querySelector('video.player') || w.querySelector('video');
        var rec = { i: i + 1, wrapper: w, video: video, events: [], head: 'not attempted', canPlay: {} };
        state.push(rec);

        if (video) {
          MEDIA_EVENTS.forEach(function (evt) {
            video.addEventListener(evt, function () {
              var extra = '';
              if (evt === 'error' && video.error) {
                extra = ' -> ' + (ERRC[video.error.code] || video.error.code) + ' "' + (video.error.message || '') + '"';
              }
              rec.events.push('[' + ms() + '] ' + evt + extra);
              render();
            });
          });
          try {
            rec.canPlay = {
              mp4_h264: video.canPlayType('video/mp4; codecs="avc1.42E01E, mp4a.40.2"') || 'no',
              mp4_hevc: video.canPlayType('video/mp4; codecs="hvc1"') || 'no',
              mp4_any:  video.canPlayType('video/mp4') || 'no'
            };
          } catch (e) { rec.canPlay = { err: e.message }; }

          /* Did a request for the file actually go out? Try a real HEAD; if CORS
             blocks it, fall back to no-cors (opaque = it left the device). */
          var url = video.currentSrc || (video.querySelector('source') && video.querySelector('source').src);
          if (url) {
            fetch(url, { method: 'HEAD', mode: 'cors' })
              .then(function (r) { rec.head = 'HEAD ' + r.status + ' ' + (r.headers.get('content-type') || ''); render(); })
              .catch(function () {
                fetch(url, { method: 'HEAD', mode: 'no-cors' })
                  .then(function () { rec.head = 'HEAD opaque (CORS-hidden status) — request DID leave the device'; render(); })
                  .catch(function (e2) { rec.head = 'HEAD FAILED: ' + e2.message; render(); });
              });
          }
        }
      });
      render();
      setInterval(render, 500);
      window.addEventListener('resize', render);
    } catch (e) {
      try { pre.textContent = 'videodebug crashed: ' + e.message; } catch (e2) {}
    }
  }

  function render() {
    if (!pre) return;
    try {
      var L = [];
      L.push('=== VIDEO DEBUG (?videodebug=1) ===');
      L.push('page      : ' + location.pathname);
      L.push('viewport  : ' + window.innerWidth + 'x' + window.innerHeight + '  dpr=' + window.devicePixelRatio);
      L.push('UA mobile : ' + (/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)));
      L.push('mm<=992   : ' + window.matchMedia('(max-width: 992px)').matches
            + '   mm<=749: ' + window.matchMedia('(max-width: 749px)').matches);
      L.push('jQuery    : ' + (typeof window.jQuery));
      L.push('wrappers  : ' + state.length);
      L.push('');

      state.forEach(function (rec) {
        var w = rec.wrapper, v = rec.video;
        var btn = w.querySelector('.play-button, .play-icon');
        L.push('--- wrapper #' + rec.i + ' ---');
        L.push('wrapper css   : ' + describeEl(w));
        L.push('yt id         : ' + (w.getAttribute('data-youtube-id') || '(none — MP4 branch)'));
        L.push('play button   : ' + (btn ? 'present ' + describeEl(btn) : 'MISSING'));
        L.push('init path     : ' + (btn ? (btn.dataset.videoOwner || 'NOT BOUND BY ANY SCRIPT') : 'n/a'));
        L.push('VIDEO ELEMENT : ' + (v ? 'PRESENT' : '*** ABSENT AT THIS BREAKPOINT ***'));

        if (v) {
          L.push('video css     : ' + describeEl(v));
          L.push('readyState    : ' + (READY[v.readyState] || v.readyState));
          L.push('networkState  : ' + (NET[v.networkState] || v.networkState));
          L.push('paused        : ' + v.paused + '   muted: ' + v.muted
                + '   playsInline: ' + v.playsInline + '   loop: ' + v.loop);
          L.push('attrs         : playsinline=' + v.hasAttribute('playsinline')
                + ' webkit=' + v.hasAttribute('webkit-playsinline')
                + ' preload=' + v.preload + ' poster=' + (v.getAttribute('poster') ? 'yes' : 'no'));
          L.push('currentTime   : ' + v.currentTime.toFixed(2) + '  duration: ' + (isNaN(v.duration) ? 'NaN' : v.duration.toFixed(1)));
          L.push('error         : ' + (v.error ? (ERRC[v.error.code] || v.error.code) + ' "' + (v.error.message || '') + '"' : 'null'));
          L.push('canPlayType   : h264=' + rec.canPlay.mp4_h264 + ' hevc=' + rec.canPlay.mp4_hevc + ' any=' + rec.canPlay.mp4_any);
          /* Source selection evidence — an empty currentSrc with <source>
             children present means the element never promoted/selected one. */
          L.push('currentSrc    : ' + (v.currentSrc || '*** EMPTY — no source selected ***'));
          L.push('src attribute : ' + (v.getAttribute('src') || '(none)'));
          L.push('src property  : ' + (v.src || '(empty)'));
          L.push('src decision  : ' + (v.dataset.srcDecision || '(normalizer did not run)'));
          if (v.dataset.srcUpgraded) L.push('upgraded to   : ' + v.dataset.srcUpgraded);
          L.push('native HLS    : ' + (v.canPlayType('application/vnd.apple.mpegurl') || 'no'));
          L.push('canPlay webm  : vp9=' + (v.canPlayType('video/webm; codecs="vp9"') || 'no')
                + ' vp8=' + (v.canPlayType('video/webm; codecs="vp8"') || 'no'));
          var srcs = Array.prototype.slice.call(v.querySelectorAll('source'));
          L.push('<source> kids : ' + (srcs.length ? srcs.map(function (s) {
              return '[type=' + (s.getAttribute('type') || 'none') + '] ' + s.getAttribute('src');
            }).join('\n                ') : '(none)'));
          L.push('network       : ' + resourceEntry(v.currentSrc));
          L.push('HEAD probe    : ' + rec.head);
          L.push('outerHTML     :');
          L.push(v.outerHTML.replace(/>\s+</g, '><').slice(0, 700));
          L.push('media events  : ' + (rec.events.length ? '' : '(none fired yet)'));
          rec.events.slice(-14).forEach(function (e) { L.push('   ' + e); });
        }
        L.push('');
      });

      L.push('--- tap events (capture phase, any listener) ---');
      if (!tapLog.length) L.push('(no tap inside a .video-wrapper yet)');
      tapLog.slice(-8).forEach(function (l) { L.push(l); });
      L.push('');
      L.push('--- play() log ---');
      if (!playLog.length) L.push('(play() never called yet — tap the play button)');
      playLog.slice(-12).forEach(function (l) { L.push(l); });

      pre.textContent = L.join('\n');
    } catch (e) {
      pre.textContent = 'videodebug render error: ' + e.message;
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* =========== END TEMPORARY DEBUG INSTRUMENTATION =========== */
